import type { InputHTMLAttributes } from 'react';
import { cn, tv, type VariantProps } from '#pie/utils/TailwindUtils';
import { styles } from '../input-text/InputText';
import { Text } from '../text/Text';

export interface InputTextAreaProps
  extends Omit<VariantProps<typeof styles>, 'hasIcon' | 'isLoading'>,
    Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'disabled' | 'onBlur'> {
  rows?: number;
  showWordCount?: boolean;
  ref?: React.Ref<HTMLTextAreaElement>;
}

export const InputTextArea = function InputTextArea({
  ref,
  className,
  disabled,
  isError,
  fullWidth,
  showWordCount = false,
  minLength,
  maxLength,
  ...props
}: InputTextAreaProps) {
  const s = inputTextArea({ disabled, fullWidth, isError });

  return (
    <div className={cn(s.base(), className)}>
      {showWordCount && maxLength && maxLength > 0 && (
        <Text className={s.wordCount()}>
          {props.value?.toString().length || 0}/{maxLength}
        </Text>
      )}
      <textarea
        data-testid={`textbox-${props.name}`}
        ref={ref}
        className={s.input()}
        disabled={disabled}
        aria-labelledby={props.name}
        maxLength={maxLength}
        {...props}
      />
    </div>
  );
};

const inputTextArea = tv({
  base: 'relative',
  extend: styles,
  slots: {
    input: 'p-3',
    wordCount:
      'text-right absolute right-0 bottom-full mb-2 text-content-tertiary',
  },
});
